import { gql } from '@apollo/client';

import routes from 'utils/routeTranslator';

type Category = {
  id: string;
  name: string;
  slug: string;
};

export type RelatedServices = Category[];

export type RelatedServicesResponse = {
  l3BySlug: { id: string; relatedServices: RelatedServices };
};

export const relatedOrdersQuery = gql`
  query RelatedOrders($slug: String!) {
    l3BySlug(slug: $slug) {
      id
      relatedServices {
        id
        name
        slug
      }
    }
  }
`;

export const getL3PathBySlug = (slug: string): string => {
  return routes.get('front::provider.register.l3', { slug });
};
